'use client';

/**
 * RescueHero Component
 *
 * Hero section featuring Chewy as the rescue dog hero
 * with animated digging effects and dramatic theming.
 */
import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { motion } from 'motion/react';
export default function RescueHero() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 opacity-10"><div className="w-full h-full" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Cpath d='M30 5 L35 25 L30 20 L25 25 Z' fill='%23fff' opacity='0.3'/%3E%3C/svg%3E\")",
        backgroundSize: "60px 60px"
      }} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 overflow-hidden pointer-events-none">{[...Array(8)].map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 20
    };
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      duration: 0.6
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3"><span className="bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-500 bg-clip-text text-transparent">Chewy's Rescue Mission</span></h1>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-lg md:text-xl text-foreground-400 mb-4 max-w-xl">Don't leave your tokens buried in dead protocols!<br /><span className="text-warning font-semibold">Let Chewy dig them up for you.</span></p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex-1 text-center md:text-left"><motion.div initial={t2} animate={t3} transition={t4}>{t5}{t6}<div className="flex flex-wrap gap-2 justify-center md:justify-start"><span className="px-3 py-1 bg-danger/20 text-danger text-sm rounded-full border border-danger/30">Rugged</span><span className="px-3 py-1 bg-warning/20 text-warning text-sm rounded-full border border-warning/30">Abandoned</span><span className="px-3 py-1 bg-default/20 text-default-500 text-sm rounded-full border border-default/30">Deprecated</span></div></motion.div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="relative w-full min-h-[280px] md:min-h-[320px] rounded-2xl overflow-hidden bg-gradient-to-br from-amber-900/40 via-amber-800/20 to-stone-900/60">{t0}{t1}<div className="relative z-10 flex flex-col md:flex-row items-center justify-between h-full p-6 md:p-8">{t7}<div className="flex-shrink-0 mt-6 md:mt-0"><motion.div className="relative w-48 h-48 md:w-56 md:h-56" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}><div className="absolute inset-0 bg-warning/30 rounded-full blur-3xl" /><Image src="/images/default/dig.svg" alt="Chewy digging for buried treasure" fill={true} className="object-contain drop-shadow-2xl" priority={true} />{[...Array(4)].map(_temp2)}</motion.div></div></div><div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-stone-800/80 to-transparent" /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function _temp2(__0, i_0) {
  return <motion.div key={i_0} className="absolute w-3 h-3 bg-yellow-300 rounded-full" style={{
    top: `${20 + i_0 * 15}%`,
    left: i_0 % 2 === 0 ? "10%" : "85%"
  }} animate={{
    scale: [1, 1.5, 1],
    opacity: [1, 0.5, 1]
  }} transition={{
    duration: 1.5,
    delay: i_0 * 0.3,
    repeat: Infinity
  }} />;
}
function _temp(_, i) {
  return <motion.div key={i} className="absolute w-4 h-4 rounded-full bg-yellow-400/60" initial={{
    x: `${10 + i * 12}%`,
    y: "100%",
    opacity: 0,
    scale: 0.5
  }} animate={{
    y: "-10%",
    opacity: [0, 1, 0],
    scale: [0.5, 1, 0.5]
  }} transition={{
    duration: 4 + i * 0.5,
    delay: i * 0.8,
    repeat: Infinity,
    ease: "easeOut"
  }} />;
}